import Requester from "../Requester";

const getRiderPendingDeliveries = (userPhone) => {
    return Requester.makeRequest(Requester.methods.GET, "agents/" + userPhone + "/deliveries")
};

const getRiderSingleDelivery = (userPhone, id) => {
    return Requester.makeRequest(Requester.methods.GET, "agents/" + userPhone + "/deliveries/" + id)
};

const getRiderStats = (userPhone) => {
    return Requester.makeRequest(Requester.methods.GET, "agents/" + userPhone + "/stats")
};

const getRiderDeliveryHistory = (userPhone) => {
    return Requester.makeRequest(Requester.methods.GET, "agents/" + userPhone + "/deliveries_history")
};


const riderUpdateDeliveryStatus = (userPhone, id, data) => {
    return Requester.makeRequest(Requester.methods.PUT, "agents/" + userPhone + "/deliveries/" + id, "", data)
};

export default {
    getRiderPendingDeliveries: getRiderPendingDeliveries,
    getRiderSingleDelivery: getRiderSingleDelivery,
    riderUpdateDeliveryStatus: riderUpdateDeliveryStatus,
    getRiderStats: getRiderStats,
    getRiderDeliveryHistory: getRiderDeliveryHistory
}
